"use client";

import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCommunitiesAdminSettings } from "./keyCommunitiesAdminSettings";
import { communitiesAdminSettingsSchema } from "./schema/communitiesAdminSettingsSchema";

export type UseRequestCommunitiesAdminSettingsProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestCommunitiesAdminSettings = ({
  id,
  ...props
}: UseRequestCommunitiesAdminSettingsProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      urlBackendPath: `/communities/${id}/settings`,
      schema: communitiesAdminSettingsSchema,
    },
    queryKey: keyCommunitiesAdminSettings({ id }),
  }),
});
